import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import imgWin from 'assets/images/eventBoatRacing/imgWin.png'
import imgBoat2 from 'assets/images/eventBoatRacing/imgBoat2.png'
import imgPhone from 'assets/images/eventBoatRacing/imgPhone.png'
import imgKip1 from 'assets/images/eventBoatRacing/imgKip1.png'
import imgKip2 from 'assets/images/eventBoatRacing/imgKip2.png'
import imgBird from 'assets/images/eventBoatRacing/imgBird.png'
import { useTranslation } from 'react-i18next'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useQuery } from 'react-query'
import {
	getCheckEventBoatRacingQuery,
	getRankEventBoatRacingQuery,
} from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'config/routes'

function ResultEventBoatRacing() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	const {
		data: eventBoatRacing,
		isLoading: isLoadingEvent,
		refetch: refetchEvent,
	} = useQuery(getCheckEventBoatRacingQuery())

	const { data: rankBoatRacing, refetch: refetchRank } = useQuery(
		getRankEventBoatRacingQuery(),
	)

	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())

	useEffect(() => {
		// refetchEvent()
		refetchRank()
	}, [user])

	useEffect(() => {
		if (eventBoatRacing && !isLoadingEvent) {
			if (!eventBoatRacing?.is_show || !eventBoatRacing?.is_finished) {
				navigate(PATHS.HOME_PAGE)
			}
		}
	}, [eventBoatRacing, isLoadingEvent])

	return (
		<div className="container-water container-boat-racing">
			<div className="container-boat-racing-wrapper">
				<Row justify="center" className="m-0">
					<Col xs={24} className="p-0">
						<div className="container-water-content container-boat-racing-content detail result">
							<div style={{ height: 'auto' }} className="box-tab-content">
								<div className="box-tab-content-detail">
									<div className="wapper-detail">
										<img srcSet={`${imgBoat2} 2x`} alt="icon page" />
										<div className="wapper-detail-box result-page">
											{!isMobileMD && (
												<>
													<img
														src={imgBird}
														alt="icon bird"
														className="img-bird bird-top"
														width={88}
													/>
													<img
														src={imgBird}
														alt="icon bird"
														className="img-bird bird-bottom"
														width={88}
													/>
												</>
											)}
											<div className="wapper-detail-box-content d-flex flex-column justify-content-center align-items-center">
												<img
													src={imgWin}
													alt="icon page"
													className="img-win"
													width={450}
												/>

												<div className="wapper-detail-win">
													<div className="wapper-detail-win-item">
														<div className="item-rank">1st prize</div>
														<img src={imgPhone} alt="icon gift" width={61} />
														<div className="item-info">
															<span>
																{rankBoatRacing?.ranks?.data[0]?.full_name}
															</span>
															<span>
																{rankBoatRacing?.ranks?.data[0]?.msisdn}
															</span>
														</div>
													</div>

													<div className="wapper-detail-win-item">
														<div className="item-rank">2nd prize</div>
														<img src={imgKip1} alt="icon gift" width={120} />
														<div className="item-info">
															<span>
																{rankBoatRacing?.ranks?.data[1]?.full_name}
															</span>
															<span>
																{rankBoatRacing?.ranks?.data[1]?.msisdn}
															</span>
														</div>
													</div>

													<div className="wapper-detail-win-item">
														<div className="item-rank">3rd prize</div>
														<img src={imgKip2} alt="icon gift" width={120} />
														<div className="item-info">
															<span>
																{rankBoatRacing?.ranks?.data[2]?.full_name}
															</span>
															<span>
																{rankBoatRacing?.ranks?.data[2]?.msisdn}
															</span>
														</div>
													</div>

													<div className="wapper-detail-win-foot">
														<p className="wapper-detail-win-foot-text">
															{t('event.boat_racing.result.page')}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default ResultEventBoatRacing
